module.exports = __webpack_public_path__ + "pc/img/main-magazine-img-05.67a072c4.jpg";